// extracted by mini-css-extract-plugin
export default {"home-page":"Home_home-page__mVVnc","texts":"Home_texts__3MHZX","text":"Home_text__0RxC2","btn":"Home_btn__LHyTH","div-img":"Home_div-img__jthuI"};